import de from 'element-ui/lib/locale/lang/de';

// 德语(德国)
export default {
  ...de,
  layout: {
    title: 'Mit Uniportal ID anmelden',
    tip: 'Nicht registrierte Handynummern werden nach erfolgreicher Anmeldung automatisch registriert',
    line: 'Andere Anmeldeoptionen',
  },
  button: {
    submit: 'Anmelden / Registrieren',
    getCode: 'Code abrufen',
    w3Login: 'W3-Kontoanmeldung',
    emailRegister: 'Per E-Mail registrieren',
    employeeLogin: 'Mitarbeiter Login',
    passwordLogin: 'Passwort Anmelden',
    reSend: 'Erneut senden',
    problem: 'Online-Hilfe',
    privacyPolicy: 'Privacy Policy',
  },
  placeholder: {
    phoneNumber: 'Mobilnummer',
    verificationCode: 'SMS-Bestätigungscode',
  },
  dialog: {
    imgCode: 'Geben Sie die auf dem Bild zu sehenden Zeichen ein.',
    userAgreements: {
      header: 'Benutzervereinbarung und Datenschutzerklärung',
      text1: 'Bitte lesen Sie die {privacy} und die{agreement} und stimmen sie ihnen zu.',
      text2:
        'Persönliche Daten werden zur Verarbeitung an die Übersee-Tochtergesellschaft von Huawei übertragen, wenn Sie auf die Übersee-App von Huawei zugreifen. Weitere Informationen finden Sie unter {privacy}',
    },
    crossBorder: {
      header: 'Autorisierungshinweise',
      text: 'Der lokale Dienst, den Sie nutzen, und der Ort, an dem Sie Ihr Konto registriert haben, befinden sich nicht in derselben Region. Für den grenzüberschreitenden Zugriff auf Kontoinformationen ist Ihre Genehmigung erforderlich.',
    },
    multiAccounts: 'Wählen Sie ein Konto.',
    agreeButton: 'Zustimmen und fortfahren',
    disagreeButton: 'Stimme nicht zu',
    confirmButton: 'Bestätigen',
    cancelButton: 'Abbrechen',
    knowMe: 'Bestätigt',
  },
  toast: {
    hasSend: 'Bestätigungscode gesendet.',
    wait: 'Einen Moment bitte.',
  },
  tooltip: {
    Huawei: 'Huawei ID',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'Der CAPTCHA-Code darf nicht leer sein.',
    'IDC-03-0002': 'Der CAPTCHA-Code ist abgelaufen.',
    'IDC-00-0004': 'Falscher CAPTCHA-Code.',

    // 表单输入为空
    'IDC-01-00024': 'Die Ländervorwahl ist erforderlich, um Ihre Mobiltelefonnummer zu bestätigen.',
    phoneNumberEmpty: 'Geben Sie die Mobiltelefonnummer ein.',
    'IDC-03-00033': 'Geben Sie den SMS-Bestätigungscode ein.',

    // 表单数据错误
    'IDC-02-00227':
      'Die eingegebene Telefonnummer stimmt nicht mit dem ausgewählten Land/der ausgewählten Region überein .',
    'IDC-02-00226': 'Der Ländercode ist verboten',
    'IDC-02-00029': 'Der Bestätigungscode ist falsch oder abgelaufen .',
    'IDC-02-0013': 'SMS-Anmeldung fehlgeschlagen . Der Bestätigungscode ist falsch .',
    'IDC-02-0020': 'Bestätigung fehlgeschlagen. Falscher Bestätigungscode.',
    'IDC-02-00028': 'Die Telefonnummer muss eine Zahl zwischen 6 und 30 sein .',
    'IDC-02-00012': 'Falsche Telefonnummer .',

    // 错误操作锁定
    accountLock:
      'Falsche Mobiltelefonnummer oder falscher Bestätigungscode. Es verbleiben {number} Versuche. | Falsche Mobiltelefonnummer oder falscher Bestätigungscode. Es verbleiben {number} Versuche.',
    accountLocked:
      'Zu viele fehlgeschlagene Versuche. Bitte versuchen Sie es in {number} Sekunden erneut. | Zu viele fehlgeschlagene Versuche. Bitte versuchen Sie es in {number} Sekunden erneut.',
    operationRisk:
      'Der aktuelle Vorgang birgt Sicherheitsrisiken . Bitte versuchen Sie es in {number} Sekunden erneut .',

    // 频繁操作
    'IDC-02-00038': 'Versuchen Sie es nach 60 Sekunden erneut.',
    'IDC-02-00064':
      'Sie haben den SMS-Verifizierungscode zu oft gesendet . Bitte versuchen Sie es in 24 Stunden erneut .',
    'IDC-02-00211':
      'Der aktuelle Vorgang birgt Sicherheitsrisiken . Bitte versuchen Sie es später erneut .',
    'IDC-02-00212':
      'Sie haben zu oft SMS-Verifizierungscodes an Ihre Telefonnummer gesendet . Bitte versuchen Sie es in 24 Stunden erneut .',
    'IDC-02-00213':
      'Sie haben den SMS-Verifizierungscode zu oft gesendet . Bitte versuchen Sie es in 24 Stunden erneut .',
    'IDC-02-00215':
      'Sie haben zu oft SMS-Verifizierungscodes an Ihre Telefonnummer gesendet . ' +
      'Bitte versuchen Sie es mit einer anderen Telefonnummer , wählen Sie eine andere Bestätigungsmethode oder versuchen Sie es in 24 Stunden erneut !',
    'IDC-02-00228':
      'Sie haben den SMS-Verifizierungscode zu oft gesendet . Bitte versuchen Sie es in 1 Stunde erneut .',
    'IDC-02-00092':
      'Der aktuelle Vorgang ist zu häufig. Bitte versuchen Sie es in 24 Stunden erneut.',

    // 请求异常
    'IDC-10-00400': 'Unerwartete Kundenanfrage',
    'IDC-10-00500': 'Interner Systemfehler ',
    'IDC-02-00264': 'Unbefugte Zugriffsanfragen sind verboten',
    'IDC-02-00063': 'Ungültiger Parameter .',
    'IDC-03-0007':
      'Der aktuelle Vorgang birgt Sicherheitsrisiken und kann vorübergehend nicht registriert werden.', // 机翻
    'IDC-03-00057': 'Der aktuelle Vorgang ist mit Sicherheitsrisiken verbunden.',

    // 页面过期
    'IDC-00-00017': 'Die Seite ist abgelaufen.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Zurück',
  closeButton: 'Schließen',

  // 滑块验证相关：
  resourceReqFailed:
    'Ressourcenanforderung fehlgeschlagen. Aktualisieren Sie die Seite und versuchen Sie es erneut.',
  verifyFailedAndPlsRetry: 'Überprüfung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  serviceErrAndPlsRetry: 'Serviceausnahme. Bitte versuchen Sie es erneut.',
  learnMore: 'Erfahren Sie mehr',
  cookieBannerText:
    'Diese Website verwendet Cookies, um Ihnen die beste Benutzererfahrung zu bieten.',
};
